import { defineStore } from "pinia";
import { ref } from "vue";
import {
	applyColorMode,
	getNextColorModePreference,
	getStoredColorModePreference,
} from "@/lib/theme";

export const useThemeStore = defineStore("theme", () => {
	const colorMode = ref(getStoredColorModePreference());

	function setColorMode(preference) {
		colorMode.value = preference;
		applyColorMode(preference);
	}

	function toggleColorMode() {
		setColorMode(getNextColorModePreference(colorMode.value));
	}

	return {
		colorMode,
		setColorMode,
		toggleColorMode,
	};
});
